import renderContentsToHTML from '@helpers/renderContentsToHTML';
import { GetEpisodeResponse } from '@models/responses';
import { GetServerSideProps } from 'next';
import React from 'react';
import Episode from '../../../src/models/Episode';
import EpisodeDetailPage from '../../../src/pages/EpisodePage';
import API from '../../../src/services';

export default function Page(props: { episode: Episode }) {
  return <EpisodeDetailPage {...props} />;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const res = await API.getEpisode(context.params.episodeId as string);
  if (res.status !== 200) throw new Error('got ' + res.status);
  let episodeData: GetEpisodeResponse = res.data;
  const errMsg = (episodeData as any).message;
  if (!episodeData.result) throw new Error(errMsg);
  if (
    episodeData.episode.purchase_episode &&
    episodeData.episode.contents.length > 0
  ) {
    if (
      !episodeData.episode.is_purchased ||
      episodeData.episode.free_listen ||
      episodeData.episode.purchase_episode
    ) {
      episodeData.episode.description = renderContentsToHTML(
        episodeData.episode.contents
      );
    } else {
      episodeData.episode.description =
        '僅訂購用戶可見，如已訂購請先使用原訂購帳戶登入';
    }
  }
  return { props: { episode: episodeData.episode } };
};
